import {BasketRuleGenqlSelection} from "@/gql/gen";

export const BasketRuleFields: BasketRuleGenqlSelection = {
    ID: true,
    CODE: true,
    NAME: true,
    ACTIVE: true,
    ALL_STOP: true,
    NAME_TEMPLATE: true,
    TYPE: true,
    IS_ADDITIONAL: true,
    PROMO: true,
    CONDITION: {
        __fragment: 'OrderCondition'
    },
    BENEFITS: {
        __typename: true,
        UID: true,
        TYPE: true,
        on_BasketRuleBenefitDiscount: {
            DISCOUNT_PERCENT: true
        },
        on_BasketRuleBenefitGift: {
            PRODUCT_ID: true
        },
    },
    PROPERTIES: {
        BENEFITS_PRODUCT_ID_ENTITIES: {
            ID: true,
            NAME: true,
        }
    }
}
